import React, { useState, useEffect, useRef, useMemo } from "react";
import { Button, Form, Input, Spin, Tabs, message, Typography, Modal } from "antd";
import {
    LockOutlined,
    MobileOutlined,
    SafetyCertificateOutlined,
    UserOutlined,
} from "@ant-design/icons";
import "./wx-login.less";
import { lib } from "react-single-app";
import md5 from "md5";
import { Send } from "../login/login";
import useRootPath from "../../components/hook/useRootPath";
import { PLATFORM_CODE } from "./types";
import useOauth from "../../components/hook/useOauth";
import { loginSuccess } from "../../utiis/common";
import HintChangePassword from "../../components/hint-change-password";
import { loginRoleList } from "../select-role";

/**
 *
 * @param  {PLATFORM_CODE} platformCode
 * @return {JSX.Element}
 * @constructor
 */
export default function WxLogin({ platformCode = PLATFORM_CODE.Wx }) {
    const [code, setCode] = useState("");
    const [needBindAccount, setNeedBindAccount] = useState(false);
    const [thirdUser, setThirdUser] = useState({});
    const [mobile, setMobile] = useState("");
    const [hintChangePassword, setHintChangePassword] = useState(false);
    const rootPath = useRootPath();
    const { isLoadingScript, initOauthLogin, getRedirectUri } = useOauth({
        rootPath: rootPath,
        loginIdentity: lib.getParam("loginIdentity"),
        platformCode: platformCode,
    });
    /**
     * 上一次登录的系统，
     */
    const loginSystem = useRef("");
    const loginRedirectUri = lib.getParam("redirectUrl");
    useEffect(() => {
        assembleWxInitState();
    }, []);

    const assembleWxInitState = () => {
        const code = lib.getParam("code");
        setCode(code);
        if (!code) {
            initOauthLogin();
        } else {
            wxLogin(code);
        }
    };
    const wxLogin = code => {
        const { host } = window.location;
        const state = lib.getParam("state");
        const loginIdentity = lib.getParam("loginIdentity");
        lib.request(
            {
                url: "/ucenter-account/oauth/login",
                data: {
                    code,
                    domain: host,
                    loginIdentity: loginIdentity,
                    platformCode,
                    state,
                },
                needMask: true,
                success: res => {
                    if (window.isWxWork && loginRedirectUri) {
                        res.loginSystem = loginRedirectUri;
                    }
                    res.loginIdentity = loginIdentity;
                    loginSystem.current = res;
                    //后端返回上一次登录的系统
                    if (res.needUpdatePwd) {
                        setHintChangePassword(true);
                    } else {
                        jumpPage();
                    }
                },
                fail(code, msg, data) {
                    if (code === -1005) {
                        setThirdUser(data);
                        toBindAccount();
                    } else if (code !== 500 && code !== -1006) {
                        Modal.error({
                            title: "异常提示",
                            content: msg,
                            onOk: () => {
                                window.location.replace(`${rootPath}/login`);
                            },
                        });
                    } else {
                        message.error(msg);
                        setTimeout(() => {
                            refreshPage();
                        }, 500);
                    }
                },
            },
            false,
        );
    };
    function refreshPage() {
        window.location.replace(
            getRedirectUri(rootPath, lib.getParam("loginIdentity"), platformCode),
        );
    }

    function toBindAccount() {
        setNeedBindAccount(true);
    }

    const bindAccount = formData => {
        const loginIdentity = lib.getParam("loginIdentity");
        const { host } = window.location;
        const { password, userName } = formData;
        lib.request({
            url: "/ucenter-account/oauth/pwd/bind",
            needMask: true,
            showToast: false,
            data: {
                userName: userName,
                password: md5(password),
                isEncrypt: true,
                domain: host,
                loginIdentity: loginIdentity,
                thirdUserId: thirdUser.thirdUserId,
                platformCode,
            },
            success: res => {
                message.success("绑定成功");
                // let redirectUrl = res?.loginSystem;
                // if (window.isWxWork && loginRedirectUri) {
                //     redirectUrl = loginRedirectUri;
                // }
                // loginSuccess(redirectUrl);
                if (window.isWxWork && loginRedirectUri) {
                    res.loginSystem = loginRedirectUri;
                }
                loginSuccess({ ...res, loginIdentity });
            },
        });
    };
    const bindSmsCodeAccount = formData => {
        const loginIdentity = lib.getParam("loginIdentity");
        const { host } = window.location;
        const { mobile, code } = formData;
        lib.request({
            url: "/ucenter-account/oauth/mobileCode/bind",
            needMask: true,
            showToast: false,
            data: {
                code: code,
                mobile: mobile,
                domain: host,
                loginIdentity: loginIdentity,
                thirdUserId: thirdUser.thirdUserId,
                platformCode,
            },
            success: res => {
                message.success("绑定成功");
                // let redirectUrl = res?.loginSystem;
                // if (window.isWxWork && loginRedirectUri) {
                //     redirectUrl = loginRedirectUri;
                // }
                // loginSuccess(redirectUrl);
                if (window.isWxWork && loginRedirectUri) {
                    res.loginSystem = loginRedirectUri;
                }
                loginSuccess({ ...res, loginIdentity });
            },
        });
    };
    function jumpPage() {
        loginSuccess(loginSystem.current);
    }
    const roleName = useMemo(() => {
        const loginIdentity = lib.getParam("loginIdentity");
        let roleName = "";
        loginRoleList.map(item => {
            if (loginIdentity === item.role) {
                roleName = item.title;
            }
        });
        return roleName;
    }, []);
    return (
        <div className={"wx-login"}>
            <Spin spinning={isLoadingScript} size={"large"} style={{ height: "100%" }}>
                {!code && !isLoadingScript ? (
                    <div style={{ textAlign: "center" }}>
                        {PLATFORM_CODE.Wx === platformCode && (
                            <div className="web_qrcode_tips">
                                <i className="web_qrcode_tips_logo"></i>
                                使用微信扫一扫
                            </div>
                        )}
                        <div id="login_container" />
                    </div>
                ) : null}
            </Spin>
            {needBindAccount && (
                <div className="bind-account-wrapper">
                    <Typography.Title level={5}>
                        {PLATFORM_CODE.QyWx === platformCode
                            ? "您企业微信綁定的手机号未匹配到对应的账号，请手动进行绑定"
                            : `请账户名/密码或手机号验证码来绑定您的微信${thirdUser.thirdUserName}的账号`}
                    </Typography.Title>
                    <div className={"login-wrap"}>
                        <div className="login-switch">
                            <div className="role-name">{roleName}</div>
                            <div
                                className="switch-btn"
                                onClick={() => {
                                    if (window.isWxWork) {
                                        location.href = "/oauth-middle-page";
                                    } else {
                                        location.href = "/select-role" + location.search;
                                    }
                                    localStorage.removeItem("role");
                                    localStorage.removeItem("roleName");
                                }}>
                                <img src="https://dante-img.oss-cn-hangzhou.aliyuncs.com/21934613682.svg" />
                                切换身份
                            </div>
                        </div>
                        <div className={"bind-account"}>
                            <Tabs
                                defaultActiveKey="1"
                                tabBarStyle={{
                                    ":before": { borderBottom: "rgba(0, 0, 0, 0.06)" },
                                }}>
                                <Tabs.TabPane tab="用户名登录" key="1">
                                    <Form name="type1" onFinish={data => bindAccount(data)}>
                                        <Form.Item
                                            name="userName"
                                            rules={[{ required: true, message: "请输入用户名" }]}>
                                            <Input
                                                size="large"
                                                placeholder="用户名"
                                                prefix={<UserOutlined style={{ color: "#999" }} />}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="password"
                                            rules={[{ required: true, message: "请输入密码" }]}>
                                            <Input.Password
                                                size="large"
                                                placeholder="密码"
                                                prefix={<LockOutlined style={{ color: "#999" }} />}
                                            />
                                        </Form.Item>
                                        <div className={"bind-tips"}>
                                            绑定成功后，下次您可直接扫码登录
                                        </div>
                                        <Form.Item>
                                            <Button
                                                type="primary"
                                                size="large"
                                                htmlType="submit"
                                                className="login">
                                                确认绑定
                                            </Button>
                                        </Form.Item>
                                        <div></div>
                                    </Form>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="验证码登录" key="2">
                                    <Form name="type2" onFinish={data => bindSmsCodeAccount(data)}>
                                        <Form.Item
                                            name="mobile"
                                            validateTrigger={["onChange", "onSubmit", "onBlur"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请输入手机号",
                                                },
                                                {
                                                    pattern: /^\d{11}$/,
                                                    message: "手机号码格式错误",
                                                    validateTrigger: ["onBlur", "onSubmit"],
                                                },
                                            ]}>
                                            <Input
                                                size="large"
                                                placeholder="手机号"
                                                prefix={
                                                    <MobileOutlined style={{ color: "#999" }} />
                                                }
                                                onChange={e => setMobile(e.target.value)}
                                                maxLength={11}
                                            />
                                        </Form.Item>
                                        <div className="code">
                                            <Form.Item
                                                name="code"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "请输入验证码",
                                                    },
                                                    {
                                                        pattern: /^\d{0,6}$/,
                                                        message: "验证码格式错误",
                                                    },
                                                ]}>
                                                <Input
                                                    size="large"
                                                    placeholder="验证码"
                                                    prefix={
                                                        <SafetyCertificateOutlined
                                                            style={{ color: "#999" }}
                                                        />
                                                    }
                                                />
                                            </Form.Item>
                                            <Send data={{ mobile, type: "LOGIN" }} />
                                        </div>
                                        <div className={"bind-tips"}>
                                            绑定成功后，下次您可直接扫码登录
                                        </div>
                                        <Form.Item>
                                            <Button
                                                type="primary"
                                                size="large"
                                                htmlType="submit"
                                                className="login">
                                                确认绑定
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                    </div>
                </div>
            )}
            <HintChangePassword
                visible={hintChangePassword}
                onHandle={() => {
                    setHintChangePassword(false);
                }}
                jumpPage={jumpPage}
            />
        </div>
    );
}
